import * as types from './Version.types';
import Helpers from '../../../common/helpers/Helpers';
import Constants from '../../../common/constants/Constants';

export const getVersionWebAPI = () => Helpers.get(Constants.VERSION_URL, {}, false);
export const getVersionWebAPISuccess = version => ({
  type: types.GET_VERSION_WEB_API_SUCCESS,
  version
});
